import { IExplorableItemTypeInfo } from '../../models/resourceInfoParts';
import { IResult } from '../types/IResponse';
import { ICreatedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface UpdateServerWelcomeChannelInfoParams {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export interface IServerWelcomeChannelInfo extends ICreatedItem, IExplorableItemTypeInfo<'site'> {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export type IUpdateServerWelcomeChannelInfoResult = IResult & IServerWelcomeChannelInfo;

export class UpdateServerWelcomeChannelInfoRequest extends Request<UpdateServerWelcomeChannelInfoParams, IUpdateServerWelcomeChannelInfoResult> {
  constructor(params: UpdateServerWelcomeChannelInfoParams) {
    super('updateServerWelcomeChannelInfo', params);
  }
}
